<button mat-icon-button class="mx-8" [matMenuTriggerFor]="notificationsMenu">
    <!-- <mat-icon [matBadge]="newNotificationCount" [matBadgeHidden]="!newNotificationCount||newNotificationCount<1"
        matBadgePosition="above after" matBadgeColor="warn">notifications</mat-icon> -->
    <mat-icon [matBadge]="newNotificationCount" [matBadgeHidden]="newNotificationCount === 0"
        matBadgePosition="above after" matBadgeColor="warn">notifications</mat-icon>
</button>

<mat-menu #notificationsMenu="matMenu" [overlapTrigger]="false" class="notifications-menu">

    <button mat-menu-item *ngFor="let notification of newNotifications | slice:0:5; let i=index" (click)="notificationClicked()">
        <span fxLayout="row" fxLayoutAlign="start center">
            <span>{{notification.data.message | translate}}{{notification.data.message2 | translate}}{{notification.data.message3 | translate}}{{notification.data.message4 | translate}}</span>
        </span>
    </button>

    <button mat-menu-item *ngIf="!newNotifications||newNotifications.length<1" disabled>
        <span fxLayout="row" fxLayoutAlign="start center">
            <span>{{'No new notifications' | translate }}</span>
        </span>
    </button>

    <div mat-menu-item style="color:dark-grey" [routerLink]="['/notifications']">
        {{'Read all notifications' | translate }}
    </div>

</mat-menu>